import Container from '@/components/Container';
import SubContainer from '@/components/Container/SubContainer';

const KnowledgeHubSkeleton = () => {
  const topics = (
    <div className="flex gap-4">
      <div className="h-full w-full animate-pulse  bg-gray-300 py-2"></div>
      <div className="h-full w-full animate-pulse  bg-gray-300 py-2"></div>
      <div className="h-full w-full animate-pulse  bg-gray-300 py-2"></div>
      <div className="h-full w-full animate-pulse  bg-gray-300 py-2"></div>
      <div className="h-full w-full animate-pulse  bg-gray-300 py-2"></div>
      <div className="h-full w-full animate-pulse  bg-gray-300 py-2"></div>
    </div>
  );

  const themes = (
    <div className="flex items-center justify-center gap-4">
      <div className="h-full w-44   animate-pulse rounded-2xl bg-gray-300 py-5"></div>
      <div className="h-full w-44 animate-pulse  rounded-2xl bg-gray-300 py-5"></div>
      <div className="h-full w-44 animate-pulse  rounded-2xl bg-gray-300 py-5"></div>
    </div>
  );

  const title = <div className="h-full w-52 animate-pulse  rounded-2xl bg-gray-300 py-3"></div>;

  const cards = (
    <div className="flex flex-col gap-4 md:flex-row">
      <div className="h-[400px] w-full animate-pulse rounded-2xl  bg-gray-300 py-8"></div>
      <div className="h-[400px] w-full animate-pulse rounded-2xl bg-gray-300 py-8"></div>
    </div>
  );

  const divider = <div className="my-8 h-full w-full  animate-pulse rounded-2xl bg-gray-300 py-1"></div>;
  return (
    <div className={`animate-pulse`}>
      <Container className={`mt-20`}>
        <SubContainer className="col-span-12 flex flex-col gap-4 lg:col-start-11 lg:col-end-3">
          {topics}
          {themes}

          {title}
          {cards}
          {divider}

          {title}
          {cards}
          {divider}

          {title}
          {cards}
        </SubContainer>
      </Container>
    </div>
  );
};

export default KnowledgeHubSkeleton;
